import { useState, useEffect } from "react";

const REVIEWS = [
  { name: "John Batiquin", time: "A week ago", body: "Just purchased my first Omega watch and was very happy. A must visit for vintage watch collectors. Highly recommended with excellent customer service.", initials: "JB" },
  { name: "Kevin D.", time: "A month ago", body: "Excellent experience with Luxe Watches. I am based in France and received my watch perfectly and on time. Communication was smooth, clear, and very professional.", initials: "KD" },
  { name: "Haleesa Nisa", time: "9 months ago", body: "Bought a retro TAG, absolutely lovely and a very fair price. Their collection of watches is very stylish and whoever selects them has great taste.", initials: "HN" },
  { name: "Rashid Al Bastaki", time: "9 months ago", body: "Fantastic service, super friendly team. Went in for a watch service and got it back and delivered in no time. Highly recommended.", initials: "RA" },
  { name: "Mahmood AlHamad", time: "9 months ago", body: "Great experience overall. From ordering to the customer experience, it was easy and smooth. The quality was just as advertised. Definitely buying again!", initials: "MA" },
  { name: "Ali Abdallat", time: "9 months ago", body: "Customer relations at its best, very friendly and attentive team. They have the best collection of pre-owned watches I've seen in Dubai.", initials: "AA" },
];

export default function Testimonials() {
  const [i, setI] = useState(0);
  useEffect(() => { const t = setInterval(() => setI((p) => (p + 3) % REVIEWS.length), 7000); return () => clearInterval(t); }, []);
  const visible = [REVIEWS[i % REVIEWS.length], REVIEWS[(i+1) % REVIEWS.length], REVIEWS[(i+2) % REVIEWS.length]];
  return (
    <section className="bg-white py-24">
      <div className="max-w-[1500px] mx-auto px-6 md:px-12">
        <div className="text-center mb-14">
          <div className="overline mb-3">Client Testimonials</div>
          <h2 className="font-display text-4xl md:text-5xl text-dark tracking-tight">The trust of connoisseurs <em className="text-copper not-italic">worldwide.</em></h2>
        </div>
        <div className="grid md:grid-cols-3 gap-6">
          {visible.map((r, idx) => (
            <div key={idx} className="card-luxe p-7">
              <div className="flex text-copper mb-4 text-sm">★ ★ ★ ★ ★</div>
              <p className="text-gray-700 leading-relaxed text-sm">"{r.body}"</p>
              <div className="flex items-center gap-3 mt-6 pt-5 border-t border-black/5">
                <div className="w-10 h-10 rounded-full bg-copper/10 border border-copper/30 text-copper flex items-center justify-center text-xs font-medium">{r.initials}</div>
                <div>
                  <div className="text-dark text-sm">{r.name}</div>
                  <div className="text-gray-500 text-xs">{r.time}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="text-center mt-12">
          <div className="inline-flex items-center gap-3 px-6 py-4 border border-black/10 bg-[#FAF7F2]">
            <span className="font-display text-3xl text-copper">4.9</span>
            <div className="text-left">
              <div className="text-copper text-xs">★ ★ ★ ★ ★</div>
              <div className="text-[10px] uppercase tracking-luxe text-gray-600">Average Google Rating</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
